import { render, staticRenderFns } from "./practice.vue?vue&type=template&id=e8db6506&scoped=true"
import script from "./practice.vue?vue&type=script&lang=js"
export * from "./practice.vue?vue&type=script&lang=js"
import style0 from "./practice.vue?vue&type=style&index=0&id=e8db6506&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8db6506",
  null
  
)

export default component.exports